import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-413f0db5"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  id: "com_form_contet_admin midlleform"
}
const _hoisted_2 = { class: "errorform" }
const _hoisted_3 = {
  key: 0,
  class: "error-message"
}
const _hoisted_4 = {
  key: 1,
  class: "com_form_contet_admin midlleform"
}
const _hoisted_5 = { class: "com_sec1" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inner1" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "title_left" }, "登録済み企業検索")
], -1))
const _hoisted_7 = { style: {"margin-bottom":"30px"} }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required-mark" }, "提案先企業の管理者様へ提案可否を必ず確認", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required-mark" }, "※", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = {
  key: 0,
  class: "error-message",
  style: {"white-space":"pre-wrap"}
}
const _hoisted_15 = { style: {"margin-left":"-1px"} }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"2%","text-align":"right"} }),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"17"} }),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"63%"} }),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"18%"} })
  ])
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("label", { class: "required-mark" }, "※")
], -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, "提案先企業名", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, "都道府県", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, [
  /*#__PURE__*/_createTextVNode(" 住所続き "),
  /*#__PURE__*/_createElementVNode("p", { style: {"font-size":"10px","margin-bottom":"-3px"} }, "(市区町村など)")
], -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_26 = { class: "form-inline flex-container" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-group" }, null, -1))
const _hoisted_28 = {
  class: "form-group",
  style: {"margin-left":"255px"}
}
const _hoisted_29 = {
  class: "inner1",
  style: {"margin-top":"30px"}
}
const _hoisted_30 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderComponent = _resolveComponent("HeaderComponent")!
  const _component_loading_overlay = _resolveComponent("loading-overlay")!
  const _component_FooterComponent = _resolveComponent("FooterComponent")!
  const _component_BackToTop = _resolveComponent("BackToTop")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_component_HeaderComponent, { isAdminPage: true })
    ]),
    _createVNode(_component_loading_overlay, {
      active: _ctx.isLoading,
      "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isLoading) = $event)),
      "is-full-page": true
    }, null, 8, ["active"]),
    (_ctx.isInitError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_ctx.errorMessage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.errorMessage), 1))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isDataFetched)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("section", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", null, _toDisplayString(_ctx.initData.formText), 1),
            _createElementVNode("div", _hoisted_7, [
              _createTextVNode(" ※" + _toDisplayString(_ctx.initData.importDate) + "時点のデータです。提案を実施される際は", 1),
              _hoisted_8,
              _createTextVNode("     "),
              _hoisted_9,
              _createTextVNode(" いただけますようお願いいたします。"),
              _hoisted_10,
              _hoisted_11,
              _createTextVNode("マークがある項目は必須項目です。"),
              _hoisted_12,
              _createTextVNode(" ※漢数字や「－」などは登録情報と異なる可能性があるため、"),
              _hoisted_13,
              _createTextVNode("    都道府県など必要最低限の内容に留めて入力ください ")
            ]),
            (_ctx.errorMessage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.errorMessage), 1))
              : _createCommentVNode("", true),
            _createElementVNode("table", _hoisted_15, [
              _hoisted_16,
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _hoisted_17,
                  _hoisted_18,
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      id: "txtCustomerName",
                      maxlength: "255",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.inputData.customerName) = $event)),
                      ref: "txtCustomerName",
                      placeholder: "全角で入力してください",
                      style: {"height":"40px"}
                    }, null, 512), [
                      [_vModelText, _ctx.inputData.customerName]
                    ])
                  ]),
                  _hoisted_19
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_20,
                  _hoisted_21,
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      maxlength: "255",
                      class: "form-control",
                      placeholder: "全角で入力してください",
                      style: {"margin-top":"7px","height":"40px"},
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.inputData.address1) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.inputData.address1]
                    ])
                  ]),
                  _hoisted_22
                ]),
                _createElementVNode("tr", null, [
                  _hoisted_23,
                  _hoisted_24,
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      maxlength: "255",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.inputData.address2) = $event)),
                      placeholder: "全角で入力してください",
                      style: {"margin-top":"7px","height":"40px"}
                    }, null, 512), [
                      [_vModelText, _ctx.inputData.address2]
                    ])
                  ]),
                  _hoisted_25
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _hoisted_27,
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("button", {
                  type: "button",
                  name: "btnSerch",
                  class: "btn btn-footer btn-primary",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onSerch && _ctx.onSerch(...args)))
                }, " 検索 "),
                _createElementVNode("button", {
                  type: "button",
                  name: "btnClear",
                  class: "btn btn-footer btn-primary",
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onClear && _ctx.onClear(...args)))
                }, " クリア ")
              ])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("h4", null, _toDisplayString(_ctx.serchResult), 1),
              (_ctx.serchResult)
                ? (_openBlock(), _createElementBlock("div", _hoisted_30, " ※ウィズカウネット、べんりねっとの登録企業件数 "))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _createVNode(_component_FooterComponent)
    ]),
    _createVNode(_component_BackToTop)
  ], 64))
}